<div class="menu-item-wrapper" [class.menu-item-locked]="locked">
  <div class="menu-item-row">
    <p-button *ngIf="type === 'button'" class="menu-item" [class.active]="active === path && subItems.length === 0"
      label="{{ value }}"
      variant="text"
      severity="secondary"
      icon="{{ icon }}"
      size="small"
      (click)="navigate()"
      [badge]="subItems.length > 0 ? (expanded ? '\u02C5' : '\u203A') : ''">
    </p-button>
    <i *ngIf="locked && type === 'button'" class="pi pi-lock lock-icon" [title]="'shell.lockedTooltip' | transloco"></i>
  </div>
  <div *ngIf="expanded && subItems.length > 0" class="submenu">
    <p-button *ngFor="let item of subItems"
        class="menu-item"
        [class.active]="isActive(item.path)"
        variant="text"
        severity="secondary"
        [label]="item.value"
        [icon]="item.icon"
        size="small"
        (click)="navigateSub(item.path)">
    </p-button>
</div>
<div *ngIf="type === 'switch'" class="switch-menu-item">
  <i *ngIf="icon" class="pi {{ icon }}"></i>
  <span> {{ value }}</span>
  <p-toggleSwitch [class.active]="active" size="small" (change)="navigate()"></p-toggleSwitch>
</div>